
var main_path = document.location.href;
main_path = main_path.replace(/\/[^\/?#]*([?#].*)?$/, '/');

//const ajaxMainThemeUrlPrefix = document.location.origin + '/wp-content/themes/odds-scanner-main/ajax/';
//const ajaxChildThemeUrlPrefix = document.location.origin + '/wp-content/themes/os-betting-child/ajax/';
const ajaxMainThemeUrlPrefix = main_path + 'wp-content/themes/odds-scanner-main/ajax/';
const ajaxChildThemeUrlPrefix = main_path + 'wp-content/themes/os-betting-child/ajax/';



// Onload
function onLoad() {
    setCowntdown();
    smoothHref();

    //dropCookie();
    //bannerManager();

    trackContentScroll();
    trackSportsbookCardScroll();
    addSidebarContentNavigationHeight();

    trackLazyLoading();

    // Escape Listeners
    // notRecommendedPopUpEscape(); 
    // megaMenuEscape();
    // searchModalEscape();

    menuStates();
    checkInformation();
    //darkligthStates();
    jQuery('input[type="range"]').on('input', rangeInputChangeEventHandler);
    if (search_archive) searchArchiveLayoutOnLoad();

    const popUpCredibility = jQuery('section.pop-ups #credibility-pop-up');
    if(popUpCredibility && popUpCredibility.length > 0) jQuery(popUpCredibility).attr('onclick', 'togglePopUpOnClickOutside(event)');
};

// Check Information
function checkInformation() {
    if (jQuery('.information').length > 0) {

        var valor = 0; // Example value, replace with your actual value

        const cardElementsL = jQuery('.information-card .card .left > div');

        cardElementsL.each(function () {
            if (valor % 2 === 0) {
                //console.log('Valor is even');
            } else {

                $(this).addClass('grow');
            }
            valor += 1;
        });

        const cardElementsC = jQuery('.information-card .card .center > div');
        cardElementsC.each(function () {

            if (valor % 2 === 0) {
                // console.log('Valor is even');
            } else {
                $(this).addClass('grow');
            }
            valor += 1;
        });
        const cardElementsR = jQuery('.information-card .card .right > div');
        cardElementsR.each(function () {

            if (valor % 2 === 0) {
                // console.log('Valor is even');
            } else {
                $(this).addClass('grow');
            }
            valor += 1;
        });

    }
}

/// DARK LIGH COOKIE
function setCookieDarkMode(name, value, days) {

    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Converte dias em milissegundos
    const expires = "expires=" + date.toUTCString();

    document.cookie = `${name}=${value}; ${expires}; path=/`;
}

function darkligthStates(state) {
    jQuery('html').attr('data-theme', state);
    //jQuery('.language-menu').addClass('closed');
    jQuery('.theme div').removeClass('active');
    jQuery('.' + state).addClass('active');

    setCookieDarkMode('data-theme', state, 400);
    setCookieDarkMode('data-state', '', 400);

    jQuery('header .language .icon').toggleClass('active');
    if (jQuery('body').hasClass('widget-template-template')) {
        location.reload();
    }

}
//CHECK PREFERENCES
function isDarkMode() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}
// Function to update the theme based on the user's preference
function updateTheme() {
    if (isDarkMode()) {
        jQuery('html').attr('data-theme', 'dark');
        setCookieDarkMode('data-theme', 'dark', 400);
        setCookieDarkMode('data-state', 'auto', 400);
    } else {
        jQuery('html').attr('data-theme', 'light');
        setCookieDarkMode('data-theme', 'light', 400);
        setCookieDarkMode('data-state', 'auto', 400);
    }
    jQuery('.language-menu').addClass('closed');
    jQuery('.theme div').removeClass('active');

}

// Listen for changes in the color scheme preference
//window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateTheme);


// Lazy Loading
function trackLazyLoading() {
    const lazyImages = jQuery('.lazy-loaded');

    let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                let lazyImage = entry.target;
                if (lazyImage.tagName == 'DIV') lazyImage.style.backgroundImage = 'url("' + lazyImage.dataset.src + '")';
                else lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.remove("lazy-loaded");
                lazyImageObserver.unobserve(lazyImage);
            }
        });
    });

    lazyImages.each(function () {
        lazyImageObserver.observe(this);
    });
}


// MENUS STATES
function menuStates() {

    jQuery(".header-menu li.current-item .menu-item a").on('mouseover', function (event) {
        if (!jQuery(".header-menu li.current-item").hasClass('open')) {
            jQuery(".header-menu li.current-item").toggleClass('open');
        }
        if (!jQuery(".language-menu").hasClass('closed')) {
            jQuery(".language-menu").addClass('closed');
        }



    });
    // jQuery(".header-menu li.current-item .menu-item a").on('click', function(event) {

    //     jQuery(".header-menu li.current-item").toggleClass('open');

    // });
    jQuery(".header-menu .label-back").on('click', function (event) {

        jQuery("li.submenu").removeClass('opened');

    });

    jQuery("main").on('mouseover', function (event) {
        if (window.innerWidth >= 1200) {
            jQuery("li.submenu").removeClass('opened');
            jQuery(".header-menu li.current-item").removeClass('open');
        }
    });
    jQuery(".header-menu>ul>li:not(.current-item) .menu-item").on('mouseover', function (event) {
        if (window.innerWidth >= 1200) {
            jQuery("li.submenu").removeClass('opened');
            jQuery(".header-menu li.current-item").removeClass('open');
        }
    });
}

function activeLang() {
    jQuery('.lang-btn').addClass('active');
    jQuery('.container.lang').removeClass('hide');
    jQuery('.dark-btn').removeClass('active');
    jQuery('.container.dark-light').addClass('hide');
}
function activeDarkLight() {
    jQuery('.lang-btn').removeClass('active');
    jQuery('.container.lang').addClass('hide');
    jQuery('.dark-btn').addClass('active');
    jQuery('.container.dark-light').removeClass('hide');
}

function closeSubmenu() {
    jQuery(".header-menu ul li.submenu").removeClass("open");
}
// FAQs
function toggleFaq(element) {
    var current_faq_card = jQuery(element).parent();
    var content_block = current_faq_card.parent();
    var faq_cards = content_block[0].children;

    for (var i = 0; i < faq_cards.length; i++) {
        if (faq_cards[i] == current_faq_card[0]) {
            current_faq_card.toggleClass('open');
            current_faq_card.toggleClass('close');
        }
        else {
            jQuery(faq_cards[i]).removeClass('open');
            jQuery(faq_cards[i]).addClass('close');
        }
    }
}

// Accordion
function toggleAccordion(element) {
    var current_faq_card = jQuery(element).parent();
    var content_block = current_faq_card.parent();
    var faq_cards = content_block[0].children;

    for (var i = 0; i < faq_cards.length; i++) {
        if (faq_cards[i] == current_faq_card[0]) {
            current_faq_card.toggleClass('open');
            current_faq_card.toggleClass('close');
        }
        else {
            jQuery(faq_cards[i]).removeClass('open');
            jQuery(faq_cards[i]).addClass('close');
        }
    }
}


// Mega Menu
function toggleMenuSidebarOnClick() {
    jQuery('section.menu-sidebar').toggleClass('open');
    //jQuery('.mega-menu .menu .current-item .nav li.submenu').removeClass('d-none');
}
// Language Switcher

function toggleLanguageSwitcher() {
    jQuery('header .language .icon').toggleClass('active');
    jQuery('header li.current-item').removeClass('open');
    jQuery('header .language-menu').toggleClass('closed');
    jQuery('.mega-menu').addClass('closed');
}


function openSubmenu(element) {
    jQuery(element).parent().parent().toggleClass('opened');

    if (jQuery(element).parent().parent().hasClass('submenu')) {

        jQuery('.mega-menu .menu .current-item .nav li.submenu:not(.opened)').addClass('d-none');

    }

    jQuery(element).attr('aria-expanded', 'true');

}

function closeSubmenuOnClick() {
    const megaMenu = jQuery('section.mega-menu');
    jQuery('.mega-menu .menu .current-item .nav li.submenu').removeClass('d-none');
    megaMenu.find('.menu-header .close-icon').removeClass('hide');
    megaMenu.find('.menu-header .close-submenu-icon').addClass('hide');

    megaMenu.find('.menu ul li.opened').removeClass('opened');
}

function closeMegaMenuSubmenuOnClick(element) {
    const megaMenu = jQuery('section.mega-menu');
    jQuery('.mega-menu .menu .current-item .nav li.submenu').removeClass('d-none');

    jQuery(element).closest('.menu ul li.opened').find('button:not(.label-back)').eq(0).attr('aria-expanded', 'false');

    jQuery(element).closest('.menu ul li.opened').removeClass('opened');
}

function selectCompetitionOnClick(element) {
    const competition = jQuery(element);

    if (competition.hasClass('active')) return;

    const competitionId = competition.attr('data-competition-id');

    const competitionWrapperItems = jQuery('.competitions.wrapper .item');
    competitionWrapperItems.each(function () {
        if (jQuery(this).attr('data-competition-id') == competitionId) jQuery(this).addClass('active');
        else jQuery(this).removeClass('active');
    });

    const teamsWrappers = jQuery('.teams.wrapper');
    teamsWrappers.each(function () {
        if (jQuery(this).attr('data-competition-id') == competitionId) jQuery(this).removeClass('hide');
        else jQuery(this).addClass('hide');
    });
}

/* Correio Braziliense
    function megaMenuEscape() {
        jQuery(document).click(event => {
            const divToEscape = jQuery('section.mega-menu');

            const divToIgnoreIfClicked = jQuery('.action-mega-menu.toggle');

            if(divToEscape.length > 0) {
                if((!divToEscape.is(event.target) && divToEscape.has(event.target).length == 0) && !divToIgnoreIfClicked.is(event.target) && divToIgnoreIfClicked.has(event.target).length == 0) {
                    divToEscape.addClass('closed');

                    //jQuery('body').removeClass('mega-menu-open');
                }
            }
        })
    }
*/


// Show More
function actionShowMore(element) {
    jQuery(element).parent().find('.cards > .responsiveness:lt(5)').removeClass('responsiveness');
    jQuery(element).parent().find('.cards > .hide:lt(5)').removeClass('hide');

    jQuery('.sportsbooks .cards > .card').length;

    var countz = 0;

    $('.sportsbooks .cards').find('.card').each(function () {
        if ($(this).hasClass("hide"))
            countz++;
    });
    if (countz == 0) {
        jQuery('.sportsbooks .show-more').addClass('responsiveness'); jQuery('.sportsbooks .show-less').toggleClass('responsiveness');
    }

}
// Show Less
function actionShowLess(element) {
    jQuery(element).parent().find('.cards > .card').addClass('hide');
    jQuery(element).parent().find('.cards > .card:lt(10)').removeClass('hide');
    jQuery('.sportsbooks .show-more').toggleClass('responsiveness');
    jQuery('.sportsbooks .show-less').toggleClass('responsiveness');
}


// Show More Less Hero Content
function actionShowMoreLessContent(element) {
    var children = jQuery(element).parent().children();

    for (var i = 0; i < children.length; i++) jQuery(children[i]).toggleClass('hide');
}


// Content Navigation Action
function actionActiveContentNavigationItem(element) {

    jQuery(element).parent().find('li').removeClass('active');

}

let currentHeadingIndex = 0;
function trackContentScroll() {
    if (jQuery('.widget-content-navigation').length > 0) {
        let headingsHeightArray = [];

        const contentBlockHeadings = jQuery('.content h2');
        contentBlockHeadings.each(function () {
            headingsHeightArray.push(jQuery(this).offset().top - 800);
        });

        jQuery(window).scroll(function (e) {

            if (!(jQuery(this).is(':animated'))) {

                const height = jQuery(window).scrollTop();

                for (let i = 0; i < headingsHeightArray.length; i++) {

                    if (height > headingsHeightArray[i] + 250) {

                        if (i != currentHeadingIndex) {
                            jQuery('.widget-content-navigation ul li').each(function () { if (jQuery(this).hasClass('active')) jQuery(this).removeClass('active') })
                            jQuery('.widget-content-navigation ul li').eq(i).addClass('active');
                        }

                        currentHeadingIndex = i;
                    }
                }
            }
        });
    }
}

function addSidebarContentNavigationHeight(extraPadding = 45) {
    if (window.innerWidth < 1200) return;

    const viewportHeight = window.innerHeight;

    const widgetBanner = jQuery('.fixed-bottom-area .widget-banner')[0];
    let widgetBannerHeight = widgetBanner ? widgetBanner.offsetHeight : 0;

    const header = jQuery('header')[0];
    let headerHeight = header ? header.offsetHeight : 0;

    let sidebarHeight = viewportHeight - widgetBannerHeight - headerHeight - extraPadding;

    const sidebarContentNavigationDiv = jQuery('.col-xl-3 .sidebar')[0];
    if (sidebarContentNavigationDiv) sidebarContentNavigationDiv.style.height = `${sidebarHeight}px`;
}

function adjustSidebarContentNavigationHeight(extraPadding = 45) {
    if (window.innerWidth < 1200) return;

    const viewportHeight = window.innerHeight;

    const header = jQuery('header')[0];
    let headerHeight = header ? header.offsetHeight : 0;

    let sidebarHeight = viewportHeight - headerHeight - extraPadding;

    const sidebarContentNavigationDiv = jQuery('.col-xl-3 .sidebar')[0];
    if (sidebarContentNavigationDiv) sidebarContentNavigationDiv.style.height = `${sidebarHeight}px`;
}


// Auxiliar Functions
function leftPad(num, size) {
    num = num.toString();
    while (num.length < size) num = '0' + num;

    return num;
}


// Style
function setCowntdown() {
    setInterval(function () {
        jQuery('.countdown').each(function () {
            var seconds = jQuery(this).find('.seconds > span .value');
            if (seconds[0].innerHTML == 0) {
                seconds[0].innerHTML = 59;

                var minutes = jQuery(this).find('.minutes > span .value');
                if (minutes[0].innerHTML == 0) {
                    minutes[0].innerHTML = 59;

                    var hours = jQuery(this).find('.hours > span .value');
                    if (hours[0].innerHTML == 0) {
                        hours[0].innerHTML = 23;

                        var days = jQuery(this).find('.days > span .value');
                        days[0].innerHTML = leftPad(days[0].innerHTML - 1, 2);
                    }
                    else hours[0].innerHTML = leftPad(hours[0].innerHTML - 1, 2);
                }
                else minutes[0].innerHTML = leftPad(minutes[0].innerHTML - 1, 2);
            }
            else seconds[0].innerHTML = leftPad(seconds[0].innerHTML - 1, 2);
        });
    }, 1000);
}

function smoothHref() {
    jQuery('[href*="#"]').click(function (e) {
        e.preventDefault();

        var url = this.href;
        var url_array = url.split('#');

        if (url_array[1] != '') {
            var fixed_header_height = jQuery('header')[0].offsetHeight;

            jQuery('html, body').animate({
                scrollTop: jQuery(jQuery('#' + url_array[url_array.length - 1]).offset().top)[0] - fixed_header_height - 5
            }, 500);
        }
    });
}

// Advertiser Geographical Card Reviews
function trackSportsbookCardScroll() {
    const card = jQuery('.after-footer > .container > .card > .advertiser-geographical-area');
    if (card.length > 0) {
        var heroCardHeight = jQuery('.advertiser-geographical-area.card').eq(0).offset().top;
        var footerHeight = jQuery('footer').eq(0).offset().top;

        jQuery(window).resize(function () {
            heroCardHeight = jQuery('.advertiser-geographical-area.card').eq(0).offset().top;
            footerHeight = jQuery('footer').eq(0).offset().top;
        });

        jQuery(window).scroll(function () {
            const height = jQuery(window).scrollTop();
            const viewportBottom = height + jQuery(window).height();

            if (height > heroCardHeight) card.removeClass('hide');
            else card.addClass('hide');

            if (viewportBottom > footerHeight) card.addClass('hide');
            else card.remove('hide');
        });
    }
}

function actionCardClose(element) {
    jQuery(element).parent().parent().remove();
}

// Layout
function layoutElement(tag, css_class, parent) {
    var element = document.createElement(tag);

    if (css_class !== null) element.className = css_class;

    parent.appendChild(element);

    return element;
}

function layoutImage(img_array, css_class, parent) {
    if (img_array === null) return;

    var img = document.createElement('img');

    if (css_class !== null) img.className = css_class;
    img.src = img_array['url'];
    img.alt = img_array['alt'];

    parent.appendChild(img);

    return img;
}

function layoutHeading(heading, title, css_class, parent) {
    if (title === null) return;

    var heading = document.createElement(heading);

    heading.innerHTML = title;
    if (css_class !== null) heading.className = css_class;

    parent.appendChild(heading);

    return heading;
}
function layoutContent(title, parent) {
    if (title === null) return;

    if (parent) {

        var heading = document.createElement('span');

        heading.innerHTML = title;
        parent.appendChild(heading);
        //console.log(heading);
        return heading;
    }
}

function layoutTitle(heading, title, icon, css_class, parent) {
    if (title === null && icon !== null) return layoutImage(icon, css_class, parent);
    if (title !== null && icon === null) return layoutHeading(heading, title, css_class, parent);
    if (title === null && icon === null) return;

    var div = document.createElement('div');

    if (css_class !== null) div.className = css_class;

    layoutHeading(heading, title, '', div);
    layoutImage(icon, '', div);

    parent.appendChild(div);

    return div;

}

function layoutButton(link, heading, title, icon, css_class, parent, target = null, rel = null, excerpt, excerptDiv) {

    if (link === null) return layoutTitle(heading, title, icon, css_class, parent);

    var a = document.createElement('a');

    if (css_class !== null) a.className = css_class;
    a.href = link['url'];
    a.title = link['title'];
    if (target !== null) a.target = target;
    if (rel !== null) a.rel = rel;

    if (title !== null) layoutHeading(heading, title, '', a);
    if (excerpt !== null) layoutContent(excerpt, excerptDiv);

    if (icon !== null) layoutImage(icon, '', a);

    parent.appendChild(a);

    return a;
}

function layoutScript(url, parent) {
    var script = document.createElement('script');
    script.src = url;

    parent.appendChild(script);
}

// function layoutAdvertiserGeographicalAreaButton(link, heading, title, icon, css_class, parent, target = null, rel = null, placement = null, link_type = null, section = null, rank = null, advertiser_geographical_area_identifier = null, marketing_source_identifier = null) {
//     if(link === null) return layoutTitle(heading, title, icon, css_class, parent);

//     var a = document.createElement('a');
//     a.className = 'os-ms';

//     if(css_class !== null) a.addClass(css_class);
//     a.href = link['url'];
//     a.title = link['title'];
//     if(target !== null) a.target = target;
//     if(rel !== null) a.rel = rel;
//     a.setAttribute("data-os_aga", link['title']);
//     if(placement !== null) a.setAttribute("data-os_dlp", placement);
//     if(link_type !== null) a.setAttribute("data-os_dlt", link_type);
//     if(section !== null) a.setAttribute("data-os_element", section);
//     if(advertiser_geographical_area_identifier !== null) a.setAttribute("data-os_adv_id", advertiser_geographical_area_identifier);
//     if(rank !== null) a.setAttribute("data-os_r", rank);
//     if(marketing_source_identifier !== null) a.setAttribute("data-os_ms", marketing_source_identifier);

//     if(title !== null) layoutHeading(heading, title, '', a);

//     if(icon !== null) layoutImage(icon, '', a);

//     parent.appendChild(a);

//     return a;
// }


// Cookies
function setCookie(cname, cvalue, seconds) {
    if (seconds) {
        var d = new Date();
        d.setTime(d.getTime() + (seconds * 1000));
        var expires = 'expires=' + d.toUTCString();

        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    else document.cookie = cname + '=' + cvalue + ';path=/';
}

function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }

    return '';
}

function checkCookie(new_identifier, time) {
    var identifier = getCookie(new_identifier);

    if (identifier != '') return false;
    else if (new_identifier != '' && new_identifier != null) {
        setCookie(new_identifier, new_identifier, time);

        return true;
    }
}

// Drop Cookie
function dropCookie() {
    const url = `${ajaxChildThemeUrlPrefix}drop-cookie.php`;

    jQuery.ajax({
        url: url,
        data: {
            wp_site_id: wp_site_id,
            wp_post_id: wp_post_id
        },
        success: function (data) {
            data.advertisers_geographical_areas.forEach(advertiserGeographicalArea => {
                const bodyDiv = jQuery(document.body)[0];

                const iframe = layoutElement('iframe', null, bodyDiv);
                iframe.src = advertiserGeographicalArea.donation_links.cookie_drop.url;
                iframe.style.display = 'none';
                jQuery(iframe).addClass('os-ms');
                iframe.setAttribute("data-os_element", 'Main');
                if (advertiserGeographicalArea.identifier !== null) iframe.setAttribute("data-os_adv_id", advertiserGeographicalArea.identifier);
                if (advertiserGeographicalArea.marketing_source_identifier !== null) iframe.setAttribute("data-os_ms", advertiserGeographicalArea.marketing_source_identifier);
            })
        },
        dataType: 'json'
    });
}

// Iframe 100%
function fit() {
    var iframes = document.querySelectorAll("iframe.gh-fit")

    for (var id = 0; id < iframes.length; id++) {
        var win = iframes[id].contentWindow
        var doc = win.document
        var html = doc.documentElement
        var body = doc.body
        var ifrm = iframes[id] // or win.frameElement

        if (body) {
            body.style.overflowX = "scroll" // scrollbar-jitter fix
            body.style.overflowY = "hidden"
        }
        if (html) {
            html.style.overflowX = "scroll" // scrollbar-jitter fix
            html.style.overflowY = "hidden"
            var style = win.getComputedStyle(html)
            ifrm.width = parseInt(style.getPropertyValue("width")) // round value
            ifrm.height = parseInt(style.getPropertyValue("height"))
        }
    }

    requestAnimationFrame(fit)
}

addEventListener("load", requestAnimationFrame.bind(this, fit))

// Banner Manager
/*function bannerManager() {
    const widgetAreas = jQuery('.banner-manager');

    widgetAreas.each(function () {
        const bannerManagerContainer = jQuery(this);
        const dataId = bannerManagerContainer.attr('data-id');

        if(!(dataId)) return;

        const url = `${ajaxChildThemeUrlPrefix}banner-manager.php`;
    
        jQuery.ajax({
            url: url,
            data: {
                data_id: dataId,
                wp_site_id: wp_site_id,
                wp_post_id: wp_post_id
            },
            success: function (bannerObject) {
                if(bannerObject['has_cookies']) if(getCookie('banner_close_' + dataId) != '') return;

                if(bannerObject['banner']) {
                    if(bannerObject['banner']['style']) {
                        const bannerContainer = layoutElement('div', 'banner', bannerManagerContainer[0]);
                        bannerContainer.setAttribute("data-os_element", 'Footer');
                        if(bannerObject['banner']['advertiser_geographical_area']['identifier'] !== null) bannerContainer.setAttribute("data-os_adv_id", bannerObject['banner']['advertiser_geographical_area']['identifier']);
                        if(bannerObject['banner']['advertiser_geographical_area']['marketing_source_identifier'] !== null) bannerContainer.setAttribute("data-os_ms", bannerObject['banner']['advertiser_geographical_area']['marketing_source_identifier']);

                        if(bannerObject['has_close']) {
                            const closeDiv = layoutElement('div', 'close', bannerContainer);
                            if(bannerObject['has_cookies']) jQuery(closeDiv).attr('data-id', dataId)
                            jQuery(closeDiv).click(function(e) { handleCloseBannerOnClick(e.target, bannerObject['has_cookies'] ? true : false) })
                            layoutImage(bannerObject['fields']['close_icon'], null, closeDiv);
                        }

                        for(const [key, style] of Object.entries(bannerObject['banner']['style'])) {
                            const bannerSizeElement = layoutElement('div', 'banner-size ' + key, bannerContainer);
                            layoutAdvertiserGeographicalAreaButton(bannerObject['banner']['advertiser_geographical_area']['donation_links']['widget'], null, null, style, null, bannerSizeElement, '_blank', 'nofollow',  (bannerObject['banner']['placement']['name'] !== null ? bannerObject['banner']['placement']['name'] : 'Widget'), 'Image');
                        }

                        if(bannerObject['has_cookies']) setCookie('banner_index_' + dataId, bannerObject['banner_index']);

                        return;
                    }
                };
            },
            dataType: 'json'
        });
    });
}*/

function handleCloseBannerOnClick(element, has_cookies = false) {
    const currentElement = jQuery(element);

    const closeElement = currentElement.closest('.close');
    const bannerElement = currentElement.closest('.banner');

    if (has_cookies) setCookie('banner_close_' + closeElement.attr('data-id'), '1');

    if (window.adjustSidebarContentNavigationHeight) adjustSidebarContentNavigationHeight();

    bannerElement.remove();
}


// Pagination General
function getPaginationTotalPages(entriesPerPage, totalEntries) {
    if (!entriesPerPage || !totalEntries) return 1;

    return Math.ceil(totalEntries / entriesPerPage);
}

function handlePaginationStyle(paginationDivOg, currentPage, totalPages, icon = null, navigationCallback = null, pageCallback = null, template = null) {
    let paginationDiv;

    if (template == 'search-archive') paginationDiv = jQuery(paginationDivOg).find('.pagination');
    else paginationDiv = paginationDivOg;

    let navigationFirstIconDiv = paginationDiv.find('.navigation.first');
    let navigationLastIconDiv = paginationDiv.find('.navigation.last');

    let navigationLeftIconDiv = paginationDiv.find('.navigation.left');
    if (navigationLeftIconDiv.length == 0) {
        navigationLeftIconDiv = layoutElement('div', 'navigation left', paginationDiv[0]);
        navigationLeftIconDiv.addEventListener('click', event => window[navigationCallback](event.currentTarget, -1, template));
        layoutImage(icon, null, navigationLeftIconDiv);

        navigationLeftIconDiv = jQuery(navigationLeftIconDiv);
    }
    else navigationLeftIconDiv.toggleClass('hide');

    if (currentPage != 1) {
        navigationLeftIconDiv.removeClass('hide');
        navigationFirstIconDiv.removeClass('hide');
    }
    else {
        navigationLeftIconDiv.addClass('hide');
        navigationFirstIconDiv.addClass('hide');
    }

    let pagesDiv = paginationDiv.find('.pages');
    if (pagesDiv.length == 0) pagesDiv = jQuery(layoutElement('div', 'pages', paginationDiv[0]));
    pagesDiv.children().each((index, el) => jQuery(el).remove());

    let pageNumberDiv = null;
    let pageDotsDiv = null;

    if (currentPage != 1) {
        pageNumberDiv = layoutElement('div', 'page number', pagesDiv[0]);
        pageNumberDiv.addEventListener('click', (event) => window[pageCallback](event.currentTarget, 1, template));
        layoutTitle('span', leftPad(1, 2), null, null, pageNumberDiv);
    }

    if (currentPage > 4) {
        pageDotsDiv = layoutElement('div', 'page dots', pagesDiv[0]);
        layoutHeading('span', '...', null, pageDotsDiv);
    }

    for (let i = currentPage - 2; i <= currentPage + 2; i++) {
        if (i == currentPage) {
            pageNumberDiv = layoutElement('div', 'page number current', pagesDiv[0]);
            layoutHeading('span', leftPad(i, 2), null, pageNumberDiv);
        } else if (i > 1 && i < totalPages) {
            pageNumberDiv = layoutElement('div', 'page number', pagesDiv[0]);
            pageNumberDiv.addEventListener('click', (event) => window[pageCallback](event.currentTarget, i, template));
            layoutHeading('span', leftPad(i, 2), null, pageNumberDiv);
        }
    }

    if (currentPage < totalPages - 3) {
        pageDotsDiv = layoutElement('div', 'page dots', pagesDiv[0]);
        layoutHeading('span', '...', null, pageDotsDiv);
    }

    if (currentPage != totalPages) {
        pageNumberDiv = layoutElement('div', 'page number', pagesDiv[0]);
        pageNumberDiv.addEventListener('click', (event) => window[pageCallback](event.currentTarget, totalPages, template));
        layoutHeading('span', leftPad(totalPages, 2), null, pageNumberDiv);
    }

    let navigationRightIconDiv = paginationDiv.find('.navigation.right');
    if (navigationRightIconDiv.length == 0) {
        navigationRightIconDiv = layoutElement('div', 'navigation right', paginationDiv[0]);
        navigationRightIconDiv.addEventListener('click', event => window[navigationCallback](event.currentTarget, 1, template));

        layoutImage(icon, null, navigationRightIconDiv);

        navigationRightIconDiv = jQuery(navigationRightIconDiv);
    }

    if (currentPage != totalPages) {
        navigationRightIconDiv.removeClass('hide');
        navigationLastIconDiv.removeClass('hide');
    }
    else {
        navigationRightIconDiv.addClass('hide');
        navigationLastIconDiv.addClass('hide');
    }
}

function actionPaginationNavigation(element, action, template = null) {
    // Limit conditions
    pagination_current_filter['pagination']['page'] += action;

    if (template == 'search-archive') requestSearchArchivePaginationEntries();
    else if (template == 'betting-tips-archive') requestBettingTipsPaginationEntries();
    else if (template == 'betting-tips-sport-archive') requestBettingTipsPaginationEntries();
    else if (template == 'single-authors') requestAuthorsPaginationEntries();
    else requestPaginationEntries();
}

function handlePaginationPageSelect(element, page, template = null) {
    if (jQuery(element).hasClass('current')) return;

    pagination_current_filter['pagination']['page'] = page;

    if (template == 'search-archive') requestSearchArchivePaginationEntries();
    else if (template == 'betting-tips-archive') requestBettingTipsPaginationEntries();
    else if (template == 'betting-tips-sport-archive') requestBettingTipsPaginationEntries();
    else if (template == 'single-authors') requestAuthorsPaginationEntries();
    else requestPaginationEntries();
}

function requestPaginationEntries() {
    const url = `${ajaxMainThemeUrlPrefix}pagination.php`;

    jQuery.ajax({
        url: url,
        data: {
            wp_site_id: wp_site_id,
            wp_post_id: wp_post_id,
            pagination_filter: pagination_current_filter
        },
        success: function (data) {
            pagination_current_filter.pagination.total_entries = data.total_entries;

            handlePaginationEntries(data.entries);

            const paginationDiv = jQuery('section.main .pagination');

            handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), data.pagination_icon, 'actionPaginationNavigation', 'handlePaginationPageSelect');
        },
        dataType: 'json'
    });
}

function handlePaginationEntries(wpPosts) {
    const cardsDiv = jQuery('section.main .cards');
    cardsDiv.children().each((index, el) => jQuery(el).remove());

    wpPosts.forEach(wpPost => createWpPostVerticalMediumCard(wpPost, cardsDiv[0]));
}


// Pagination Betting Tips
function handleBettingTipsPaginationEntries(paginationDiv, data) {
    const cardsDiv = jQuery('section.main .cards');
    cardsDiv.children().each((index, el) => jQuery(el).remove());

    if (data.entries) {
        let startIndex = (pagination_current_filter.pagination.page - 1) * pagination_current_filter['pagination']['entries_per_page'];
        const endIndex = (pagination_current_filter.pagination.page * pagination_current_filter['pagination']['entries_per_page']) - 1;
        var number = 0;
        while (data.entries[startIndex] && startIndex <= endIndex) {

            if (number == 0) {
                createWpPostVerticalMediumCard(data.entries[startIndex], cardsDiv[0]);
            } else if (number > 0 && number < 5) {
                createWpPostVerticalMediumCard(data.entries[startIndex], cardsDiv[1]);
            } else if (number > 4 && number < 7) {
                createWpPostVerticalMediumCard(data.entries[startIndex], cardsDiv[2]);
            } else {
                createWpPostVerticalMediumCard(data.entries[startIndex], cardsDiv[3]);
            }

            startIndex++;
            number++;
        }

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'betting-tips-archive');
    }
}

function requestBettingTipsPaginationEntries() {
    const paginationDiv = jQuery('section.main .pagination');

    if (!pagination.data) {
        pagination.fetchingData = true;

        const url = `${ajaxMainThemeUrlPrefix}betting-tips-pagination.php`;

        jQuery.ajax({
            url: url,
            data: {
                wp_site_id: wp_site_id,
                wp_post_id: wp_post_id,
                pagination_filter: pagination_current_filter
            },
            success: function (data) {
                if (!data.entries) return;

                pagination.data = {};
                pagination.data.entries = data.entries.filter(wpPost => (pagination_current_filter.filter.relationships ? pagination_current_filter.filter.relationships.includes(wpPost.parent) : true) && pagination_current_filter.filter.cpt == wpPost.type && pagination_current_filter.filter.template == wpPost.template);
                pagination.data.icon = data.pagination.icon;

                pagination_current_filter.pagination.total_entries = pagination.data.entries.length;

                handleBettingTipsPaginationEntries(paginationDiv, pagination.data);

                handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'betting-tips-archive');

                pagination.fetchingData = false;
            },
            dataType: 'json'
        });
    }
    else {
        handleBettingTipsPaginationEntries(paginationDiv, pagination.data);

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'betting-tips-archive');
    }
}


// Pagination Search
function handleSearchArchivePaginationEntries(paginationDiv, data) {
    const cardsDiv = jQuery(paginationDiv).find('.cards.pagination');
    cardsDiv.children().each((index, el) => jQuery(el).remove());

    if (data.entries) {
        const categoryEntries = data.entries.filter(wpPost => wpPost.type.toLowerCase() == pagination_current_filter.current_category.toLowerCase());

        let startIndex = (pagination_current_filter.pagination.page - 1) * pagination_current_filter['pagination']['entries_per_page'];
        const endIndex = (pagination_current_filter.pagination.page * pagination_current_filter['pagination']['entries_per_page']) - 1;

        while (categoryEntries[startIndex] && startIndex <= endIndex) {
            createWpPostVerticalMediumSearchCard(categoryEntries[startIndex], cardsDiv[0]);

            startIndex++;
        }

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, categoryEntries.length), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'search-archive');
    }
}

function requestSearchArchivePaginationEntries() {
    const category = pagination_current_filter.current_category;

    const paginationDiv = jQuery('.results.' + category);

    if (!pagination.data) {
        pagination.fetchingData = true;
        const url = `${ajaxChildThemeUrlPrefix}search-archive.php`;

        jQuery.ajax({
            url: url,
            data: {
                wp_site_id: wp_site_id,
                wp_post_id: wp_post_id,
                pagination_filter: pagination_current_filter
            },
            success: function (data) {
                if (!data.entries) return;
                pagination.data = {};
                pagination.data.entries = data.entries.filter(wpPost => wpPost.name.toLowerCase().includes(pagination_current_filter.filter.search_query.toLowerCase()));
                pagination.data.icon = data.pagination.icon;

                pagination_current_filter.pagination.total_entries = pagination.data.entries.length;

                handleSearchArchivePaginationEntries(paginationDiv, pagination.data);

                handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'search-archive');

                pagination.fetchingData = false;
            },
            dataType: 'json'
        });
    }
    else {
        const categoryEntries = pagination.data.entries.filter(wpPost => wpPost.type.toLowerCase() == category.toLowerCase());

        handleSearchArchivePaginationEntries(paginationDiv, pagination.data);

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, categoryEntries.length), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'search-archive');
    }
}


// Layout Single Authors
function requestAuthorsPaginationEntries() {
    const paginationDiv = jQuery('.pagination');

    if (!pagination.data) {
        pagination.fetchingData = true;
        const url = `${ajaxChildThemeUrlPrefix}authors.php`;

        jQuery.ajax({
            url: url,
            data: {
                wp_site_id: wp_site_id,
                wp_post_id: wp_post_id,
                pagination_filter: pagination_current_filter
            },
            success: function (data) {
                if (!data.entries) return;
                pagination.data = {};
                pagination.data.entries = data.entries.filter(wpPost => wpPost.wp_author.id = pagination_current_filter.filter.wp_author.id);
                pagination.data.icon = data.pagination.icon;

                pagination_current_filter.pagination.total_entries = pagination.data.entries.length;

                handleAuthorsPaginationEntries(paginationDiv, pagination.data);

                handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'single-authors');

                pagination.fetchingData = false;
            },
            dataType: 'json'
        });
    }
    else {
        handleAuthorsPaginationEntries(paginationDiv, pagination.data);

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'single-authors');
    }
}

function handleAuthorsPaginationEntries(paginationDiv, data) {
    const cardsDiv = jQuery('.cards');
    cardsDiv.children().each((index, el) => jQuery(el).remove());

    if (data.entries) {
        let startIndex = (pagination_current_filter.pagination.page - 1) * pagination_current_filter['pagination']['entries_per_page'];
        const endIndex = (pagination_current_filter.pagination.page * pagination_current_filter['pagination']['entries_per_page']) - 1;

        while (data.entries[startIndex] && startIndex <= endIndex) {
            createWpPostVerticalMediumCard(data.entries[startIndex], cardsDiv[0]);

            startIndex++;
        }

        handlePaginationStyle(paginationDiv, pagination_current_filter.pagination.page, getPaginationTotalPages(pagination_current_filter.pagination.entries_per_page, pagination_current_filter.pagination.total_entries), pagination.data.icon, 'actionPaginationNavigation', 'handlePaginationPageSelect', 'single-authors');
    }
}

// Layout Wp Posts
function createWpPostVerticalMediumCard(wpPost, parent, index) {
    const wpPostDiv = layoutElement('div', 'wp-post vertical medium card', parent);

    layoutButton(wpPost.link, null, null, null, 'area-link', wpPostDiv);

    const wrapperDiv = layoutElement('div', 'wrapper', wpPostDiv);

    const topDiv = layoutElement('div', 'top', wrapperDiv);
    if (wpPost.category) {
        const tagDiv = layoutElement('div', 'tag', topDiv);
        const tag = layoutHeading('span', wpPost.category, null, tagDiv);
    }

    const featuredImageDiv = layoutElement('div', 'featured-image', topDiv);
    if (wpPost.featured_image && wpPost.featured_image.url) {
        featuredImageDiv.style.backgroundImage = `url(${wpPost.featured_image.url})`;
    } else {
        if (wpPost.default_featured_image && wpPost.default_featured_image.url) featuredImageDiv.style.backgroundImage = `url(${wpPost.default_featured_image.url})`;
    }

    const bottomDiv = layoutElement('div', 'bottom', wrapperDiv);

    const detailsDiv = layoutElement('div', 'details', bottomDiv);

    const titleDiv = layoutElement('div', 'title', detailsDiv);
    const title = layoutButton(wpPost.link, 'span', wpPost.title, null, null, titleDiv);

    const publishedDateDiv = layoutElement('div', 'publish-date', detailsDiv);
    const publishedDate = layoutHeading('span', wpPost.date_published, null, publishedDateDiv);
}

function createWpPostVerticalMediumSearchCard(wpPost, parentDiv) {
    const wpPostDiv = layoutElement('div', 'wp-post vertical medium search card', parentDiv);

    layoutButton(wpPost.link, null, null, null, 'area-link', wpPostDiv);

    const wrapperDiv = layoutElement('div', 'wrapper', wpPostDiv);

    const topDiv = layoutElement('div', 'top', wrapperDiv);
    if (wpPost.category) {
        const tagDiv = layoutElement('div', 'tag', topDiv);
        const tag = layoutHeading('span', wpPost.category, null, tagDiv);
    }

    const featuredImageDiv = layoutElement('div', 'featured-image', topDiv);
    if (wpPost.featured_image && wpPost.featured_image.url) {
        featuredImageDiv.style.backgroundImage = `url(${wpPost.featured_image.url})`;
    } else {
        if (wpPost.default_featured_image && wpPost.default_featured_image.url) featuredImageDiv.style.backgroundImage = `url(${wpPost.default_featured_image.url})`;
    }

    const bottomDiv = layoutElement('div', 'bottom', wrapperDiv);

    const detailsDiv = layoutElement('div', 'details', bottomDiv);

    const titleDiv = layoutElement('div', 'title', detailsDiv);
    const title = layoutButton(wpPost.link, 'span', wpPost.title, null, null, titleDiv);

    const publishedDateDiv = layoutElement('div', 'publish-date', detailsDiv);
    const publishedDate = layoutHeading('span', wpPost.date_published, null, publishedDateDiv);
}



// Search Feature
function searchBarIconOnClick(event, filterInJs) {

    const searchBarDiv = jQuery('.search-bar.archive');

    const searchQuery = searchBarGetSearchQuery(searchBarDiv);

    if (searchQuery.length >= 3) searchBarRedirect(searchBarDiv, searchQuery);
    else return;
}
function openSearchBarOnClick(element) {
    const searchBar = jQuery(element).parent().find('.search-bar');
    searchBar.toggleClass('closed');
}

function closeSearchBarOnClick(element) {
    const searchBar = jQuery(element).closest('.search-bar');
    searchBar.toggleClass('closed');
}

/* Correio Braziliense
function searchModalEscape() {
    jQuery(document).click(event => {
        const divToEscape = jQuery('section.search-modal');

        const divToIgnoreIfClicked = jQuery('.action-search.toggle, div.no-results > .button');

        if(divToEscape.length > 0) {
            if((!divToEscape.is(event.target) && divToEscape.has(event.target).length == 0) && !divToIgnoreIfClicked.is(event.target) && divToIgnoreIfClicked.has(event.target).length == 0) {
                divToEscape.addClass('close');
    
                const searchBarDiv = jQuery('.search-bar'); 
                searchBarCleanSearchQuery(searchBarDiv);

                //jQuery('body').removeClass('search-open');
            }
        }
    })
}
*/

function searchBarGetSearchQuery(element) {

    const inputDiv = jQuery(element).closest('.search-bar').find('input');
    return inputDiv[0].value.toLowerCase();

}

function getSearchQuery() {
    const urlParams = new URLSearchParams(window.location.search);

    let searchParam = urlParams.get('search');

    return searchParam ? searchParam : '';
}

function searchBarCleanSearchQuery(element) {
    const inputDiv = jQuery(element).closest('.search-bar').find('input');
    inputDiv[0].value = '';
}

function handleSearchSubmit(element) {
    const searchBarDiv = jQuery(element).closest('.search-bar');

    let searchQuery = searchBarGetSearchQuery(searchBarDiv);

    if (searchQuery.length >= 3) searchBarRedirect(searchBarDiv, searchQuery);
}

function handleSearchSubmitOnEnter(event, element) {
    const searchQuery = searchBarGetSearchQuery(element);
    //console.log($(searchQuery).val());
    const searchBars = jQuery('.search-bar');
    //console.log('click key');
    searchBars.each(function () {
        jQuery(this).find('input')[0].value = searchQuery;
    });
    //console.log(element); 

    if (event.key === 'Enter') {
        event.preventDefault();
        handleSearchSubmit(element);
    }
}

function searchBarRedirect(searchBarDiv, searchQuery) {
    const archivePageUrl = searchBarDiv.find('[data-archive-page-url]')[0].dataset.archivePageUrl;

    window.location.href = `${archivePageUrl}?search=${searchQuery}`;
}
function searchBarRedirectIcon(searchBarDiv) {
    const archivePageUrl = $(searchBarDiv).attr('data-archive-page-url');
    //data-archive-page-url
    window.open(`${archivePageUrl}`, '_blank');
}
function searchArchiveLayoutOnLoad() {
    const resultsWrapperDiv = jQuery('.results-wrapper')[0];

    if (!pagination.data) {
        pagination.fetchingData = true;

        const url = `${ajaxChildThemeUrlPrefix}search-archive.php`;

        jQuery.ajax({
            url: url,
            success: function (data) {

                if (!data.entries) {
                    cleanSearchArchiveLayout();
                    searchArchiveLayoutNoResultsStyles(resultsWrapperDiv);
                    return;
                };

                pagination.data = {};
                pagination.data.entries = data.entries.filter(wpPost => wpPost.name.toLowerCase().includes(pagination_current_filter.filter.search_query.toLowerCase()));
                pagination.data.icon = data.pagination.icon;

                pagination_current_filter.pagination.total_entries = pagination.data.entries.length;

                if (pagination.data.entries.length == 0) searchArchiveLayoutNoResultsStyles(resultsWrapperDiv);

                pagination.fetchingData = false;
            },
            dataType: 'json'
        });
    }
    else {
        pagination.data.entries = pagination.data.entries.filter(wpPost => wpPost.name.toLowerCase().includes(pagination_current_filter.filter.search_query.toLowerCase()));

        const categories = getSearchArchiveCategoriesFromEntries(pagination.data.entries);
        pagination_current_filter.pagination.total_entries = pagination.data.entries.length;

        if (pagination.data.entries.length == 0) searchArchiveLayoutNoResultsStyles(resultsWrapperDiv, pagination_default_filter.no_results_styles);
        else searchArchiveLayoutResultsStyles(resultsWrapperDiv, pagination_current_filter, pagination.data.entries, pagination_default_filter.results_styles, pagination.styles, categories, true, null, pagination_current_filter.filter.search_query);
    }
}

function getSearchArchiveCategoriesFromEntries(entries) {
    if (entries.length == 0) return [];

    let categories = {};

    let startIndex = 0;
    const endIndex = entries.length - 1;

    while (entries[startIndex] && startIndex <= endIndex) {
        if (entries[startIndex].type && categories[entries[startIndex].type] == undefined) categories[entries[startIndex].type] = 1;
        else categories[entries[startIndex].type]++;

        startIndex++;
    };

    return categories;
}

function searchArchiveLayoutResultsStyles(parentDiv, paginationCurrentFilter, paginationDataEntries, resultsStyles, paginationStyles, categories = null, onload = false, category = null, query = null) {
    paginationCurrentPage = paginationCurrentFilter.pagination.page;
    paginationEntriesPerPage = paginationCurrentFilter.pagination.entries_per_page * 1;
    paginationTotalEntries = paginationCurrentFilter.pagination.total_entries * 1;

    if (!categories) categories = getSearchArchiveCategoriesFromEntries(pagination.data.entries);

    if (onload) {
        var categoriesDivs = {};

        const introductionDiv = layoutElement('div', 'introduction', parentDiv);

        if (query && query.length > 0) {
            const titleDiv = layoutElement('div', 'title', introductionDiv);
            const title = layoutHeading(resultsStyles.introduction_title.heading, paginationTotalEntries + ' ' + (paginationTotalEntries != 1 ? resultsStyles.introduction_title.middle.plural : resultsStyles.introduction_title.middle.single), null, titleDiv);
            const span = layoutHeading('span', ' "' + paginationCurrentFilter.filter.search_query + '"', null, title);
        }

        const filtersDiv = layoutElement('div', 'filters', introductionDiv);
        const allDiv = layoutElement('div', 'filter all active', filtersDiv);
        const allFilter = layoutHeading('span', resultsStyles.labels_filters.all, null, allDiv);
        allDiv.addEventListener('click', event => handleSearchArchiveFilterSelect(event.currentTarget, 'all'));

        const categoriesKeys = Object.keys(categories);
        for (let i = 0; i < categoriesKeys.length; i++) {
            const categoryFilterDiv = layoutElement('div', 'filter ' + categoriesKeys[i].toLowerCase().replace(/\s+/g, '-'), filtersDiv);
            const categoryFilter = layoutHeading('span', resultsStyles.labels_filters[categoriesKeys[i]] + ' <span>(' + categories[categoriesKeys[i]] + ')</span>', null, categoryFilterDiv);
            categoryFilterDiv.addEventListener('click', event => handleSearchArchiveFilterSelect(event.currentTarget, categoriesKeys[i]));
        }

        const resultsDiv = layoutElement('div', 'results-container', parentDiv);

        for (let i = 0; i < categoriesKeys.length; i++) {
            const categoryResultsDiv = layoutElement('div', 'results active ' + categoriesKeys[i].toLowerCase().replace(/\s+/g, '-'), resultsDiv);

            const introductionDiv = layoutElement('div', 'introduction', categoryResultsDiv);

            const titleDiv = layoutElement('div', 'title decored', introductionDiv);
            const title = layoutHeading('h4', resultsStyles.labels_filters[categoriesKeys[i]], null, titleDiv);

            const navigationDiv = layoutElement('div', 'navigation-container preview responsiveness', introductionDiv);

            const navigationLeftDiv = layoutElement('div', 'navigation left', navigationDiv);
            navigationLeftDiv.addEventListener('click', event => handleSearchCardsNavigation(event.currentTarget, -1));
            const iconLeftDiv = layoutImage(resultsStyles.style_navigation_icon, null, navigationLeftDiv);

            const navigationRightDiv = layoutElement('div', 'navigation right', navigationDiv);
            navigationRightDiv.addEventListener('click', event => handleSearchCardsNavigation(event.currentTarget, 1));
            const iconRightDiv = layoutImage(resultsStyles.style_navigation_icon, null, navigationRightDiv);

            const cardsDiv = layoutElement('div', 'cards preview grid-four', categoryResultsDiv);

            const seeMoreDiv = layoutElement('div', 'see-more preview', categoryResultsDiv);
            const seeMore = layoutTitle('span', resultsSeeMoreTitle, null, null, seeMoreDiv);
            seeMoreDiv.addEventListener('click', () => handleSeeMoreResults(this, categoriesKeys[i]));

            const cardsPaginationDiv = layoutElement('div', 'cards pagination grid-four', categoryResultsDiv);

            categoriesDivs[categoriesKeys[i]] = categoryResultsDiv;
        }

        if (paginationDataEntries) {
            const endIndex = resultsStyles.preview_display ? resultsStyles.preview_display : 8;

            for (let i = 0; i < categoriesKeys.length; i++) {
                let startIndex = 0;
                const categoryEntries = paginationDataEntries.filter(wpPost => wpPost.type.toLowerCase() == categoriesKeys[i].toLowerCase());

                const resultsCardsDiv = categoriesDivs[categoriesKeys[i]].querySelector('.cards.preview');
                while (categoryEntries[startIndex] && startIndex < endIndex) {
                    createWpPostVerticalMediumSearchCard(categoryEntries[startIndex], resultsCardsDiv);
                    startIndex++;
                }

                if (categoryEntries.length <= endIndex) {
                    categoriesDivs[categoriesKeys[i]].querySelector('.see-more.preview').remove();
                }
            }
        }
    }

    else {
        if (paginationDataEntries) {
            const resultsDiv = jQuery('.results-container');

            const categoryEntries = paginationDataEntries.filter(wpPost => wpPost.type.toLowerCase() == category.toLowerCase());
            const categoryTotalEntries = categoryEntries.length;
            let startIndex = (paginationCurrentPage - 1) * paginationEntriesPerPage;
            const endIndex = (paginationCurrentPage * paginationEntriesPerPage) - 1;

            const resultsCategoryDiv = jQuery('.results.' + category);

            const resultsCardsDiv = jQuery('.results.' + category + ' .cards.pagination');
            resultsCardsDiv.empty();
            while (categoryEntries[startIndex] && startIndex <= endIndex) {
                createWpPostVerticalMediumSearchCard(categoryEntries[startIndex], resultsCardsDiv[0]);
                startIndex++;
            }

            if (categoryTotalEntries > paginationEntriesPerPage) searchArchiveLayoutResultsBottomStyles(resultsCategoryDiv[0], paginationEntriesPerPage, categoryTotalEntries, resultsStyles, paginationStyles);
        }
    }
}

function handleSeeMoreResults(element, category) {
    const filterDiv = jQuery('.filters .filter.' + category);

    if (filterDiv && filterDiv.length > 0) {
        handleSearchArchiveFilterSelect(filterDiv[0], category)
    }
}

function searchArchiveLayoutNoResultsStyles(parentDiv, noResultsStyles) {
    const heroTitleDiv = jQuery('.no-results')[0];

    layoutHeading(noResultsStyles.introduction_title.heading, noResultsStyles.introduction_title.title, null, heroTitleDiv);

}

function searchArchiveLayoutResultsBottomStyles(parentDiv, entriesPerPage, totalEntries, resultsStyles, paginationStyles) {
    let paginationDiv;

    const paginationAux = jQuery(parentDiv).find('.pagination:not(.cards):has(.pagination .pages)');
    if (paginationAux && paginationAux.length > 0) paginationAux.remove();

    paginationDiv = layoutElement('div', 'pagination', parentDiv);

    searchArchiveLayoutPaginationStyles(paginationDiv, entriesPerPage, totalEntries, paginationStyles);
}

function searchArchiveLayoutPaginationStyles(parentDiv, entriesPerPage, totalEntries, paginationStyles) {
    let paginationTotalPages = getPaginationTotalPages(entriesPerPage, totalEntries);

    paginationDiv = layoutElement('div', 'pagination', parentDiv);

    divNavigationLeft = layoutElement('div', 'navigation left hide', paginationDiv);
    divNavigationLeft.dataset.navigation = -1;
    divNavigationLeft.addEventListener('click', event => actionPaginationNavigation(event.currentTarget, -1, 'search-archive'));
    layoutImage(paginationStyles['navigation_icon'], null, divNavigationLeft);


    divPages = layoutElement('div', 'pages', paginationDiv);

    divCurrentPageNumber = layoutElement('div', 'page number current', divPages);
    layoutHeading('span', '01', null, divCurrentPageNumber);

    for (let i = 2; i < 5; i++) {
        if (i > paginationTotalPages) break;
        divPageNumber = layoutElement('div', 'page number', divPages);
        divPageNumber.dataset.page = i;
        divPageNumber.addEventListener('click', event => handlePaginationPageSelect(event.currentTarget, i, 'search-archive'));
        layoutHeading('span', leftPad(i, 2), null, divPageNumber);
    }

    if (paginationTotalPages > 5) {
        divPageDots = layoutElement('div', 'page dots', divPages);
        layoutHeading('span', '...', null, divPageDots);


        divPageNumber = layoutElement('div', 'page number', divPages);
        divPageNumber.dataset.page = paginationTotalPages;
        divPageNumber.addEventListener('click', event => handlePaginationPageSelect(event.currentTarget, paginationTotalPages, 'search-archive'));
        layoutHeading('span', leftPad(i, 2), null, divPageNumber);
    }

    if (paginationTotalPages > 1) {
        divNavigationRight = layoutElement('div', 'navigation right', paginationDiv);
        divNavigationRight.dataset.navigation = +1;
        divNavigationRight.addEventListener('click', event => actionPaginationNavigation(event.currentTarget, +1, 'search-archive'));
        layoutImage(paginationStyles['navigation_icon'], null, divNavigationRight);
    }
}

function handleSearchArchiveFilterSelect(element, filter) {
    pagination_current_filter.current_category = filter;
    pagination_current_filter.pagination.page = 1;

    const filterDiv = jQuery(element);

    if (filterDiv.hasClass('active')) return;

    const activeFilterDiv = filterDiv.parent().find('.filter.active');

    activeFilterDiv.removeClass('active');
    filterDiv.addClass('active');

    if (filter == 'all') {
        const resultsDivs = jQuery('.results-container > .results');
        resultsDivs.each((index, el) => {
            jQuery(el).addClass('active');
        });
    }
    else {
        const resultsDivs = jQuery('.results-container > .results' + (filter ? '.' + filter : ''));

        searchArchiveLayoutResultsStyles(resultsDivs, pagination_current_filter, pagination.data.entries, pagination_default_filter.results_styles, pagination.styles, null, false, filter);

        const activeResultDiv = jQuery('.results-container > .results.active');
        const resulsDiv = jQuery('.results-container > .results' + (filter ? '.' + filter : ''));

        activeResultDiv.removeClass('active');
        resulsDiv.addClass('active');
    }
}

function searchArchiveLayoutSearchQuery() {
    const searchQueryStringDiv = jQuery('.search-query-string');
    searchQueryStringDiv[0].innerHTML = getSearchQuery();
}

function cleanSearchArchiveLayout() {
    const resultsWrapperDiv = jQuery('.results-wrapper');
    resultsWrapperDiv.empty();
}

// Search Bar not used and to be analysed
/*
function searchBarCleanUp(searchBarDiv) {
    const bottomDiv = searchBarDiv.find('> .bottom');

    bottomDiv.addClass('hide');

    searchBarCleanWpPosts(bottomDiv.find('.wp-posts'));

    bottomDiv.find('.pagination').remove();
}

function searchBarCleanWpPosts(wpPostsDiv) {
    wpPostsDiv.children().each((index, el) => jQuery(el).remove());
}
*/
function searchBarOnKeyUp(event, filterInJs) {

    const searchBarDiv = jQuery(event.target).closest('.search-bar');

    const searchQuery = searchBarGetSearchQuery(searchBarDiv);

    pagination_current_filter['pagination']['page'] = 1;

    if (searchQuery.length > 3) {
        if (searchBarDiv.closest('section.results').length > 0) {
            pagination_current_filter['filter']['search_query'] = searchQuery;

            requestPaginationEntries(searchBarDiv[0]);
        }
    }

    if (event.code == 'Enter' && searchQuery.length >= 3) {
        searchBarRedirect(searchBarDiv, searchQuery);
        return;
    }
}
/*
function searchBarGetData() {
    searchBarFetchingData = true;

    const url = `${ajaxMainThemeUrlPrefix}search.php`;

    jQuery.ajax({
        url: url,
        data: {
        },
        success: function(data) {
            searchBar.data = data;

            searchBarFetchingData = false;
        },
        dataType: 'json'
    });
}

function searchBarHandleData(searchBarDiv, searchQuery) {
    searchQuery = searchBarGetSearchQuery(searchBarDiv.children(':first')[0]); // Hack to make sure searchquery is updated to the user input

    const bottomDiv = searchBarDiv.find('.bottom');
    bottomDiv.removeClass('hide');

    const wpPostsDiv = bottomDiv.find('.wp-posts');

    let createdWpPostDiv = false;

    searchBarCleanWpPosts(wpPostsDiv);

    if(searchBar.data.results) {
        let postsWithinSearchQuery = 0;

        const startIndex = (search_bar_pagination_current_filter.pagination.page - 1) * search_bar_pagination_current_filter['pagination']['entries_per_page'];
        const endIndex = search_bar_pagination_current_filter.pagination.page * search_bar_pagination_current_filter['pagination']['entries_per_page'];

        let counter = 0;

        while(searchBar.data.results[counter]) {
            if(searchBar.data.results[counter].title.toLowerCase().includes(searchQuery)) {
                postsWithinSearchQuery++;

                if(postsWithinSearchQuery > startIndex && postsWithinSearchQuery <= endIndex) {
                    createdWpPostDiv = true;

                    createWpPostVerticalSmallCard(searchBar.data.results[counter], wpPostsDiv[0]);
                }
            }

            counter++;
        }

        search_bar_pagination_current_filter['pagination']['total_entries'] = postsWithinSearchQuery;

        let paginationDiv = searchBarDiv.find('.pagination');
        if(paginationDiv.length == 0) paginationDiv = layoutElement('div', 'pagination', bottomDiv.find('> .container')[0]);

        handlePaginationStyle(jQuery(paginationDiv), search_bar_pagination_current_filter.pagination.page, getPaginationTotalPages(search_bar_pagination_current_filter.pagination.entries_per_page, search_bar_pagination_current_filter.pagination.total_entries), searchBar.data.pagination.icon, 'searchBarActionPaginationNavigation', 'searchBarHandlePaginationPageSelect', 'search-archive');
    }

    if(!searchBar.data.results || !createdWpPostDiv) {
        const noResults = layoutElement('div', 'no-results', wpPostsDiv[0]);
        layoutHeading('span', searchBar.data.no_results, null, noResults);
    }
}
*/



// Copy To Clipboard
function copyToClipboard(element, copyURL) {
    var currentElement = jQuery(element);
    if (currentElement.hasClass('information')) {
        currentElement = jQuery(element).prev().find('.title');
        currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });
    } else {
        currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });
    }

    if (!copyURL) navigator.clipboard.writeText(window.location.href);
    else {
        navigator.clipboard.writeText(copyURL);

        setTimeout(() => {
            currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });
        }, 2 * 1000);
    }
}

// Limits table
function showMoreLimitsTable(element) {

    jQuery(element).closest('table').removeClass('closed');

    jQuery(element).parent().parent().next().removeClass('closed');
}
function showLessLimitsTable(element) {

    jQuery(element).closest('table').addClass('closed');
    jQuery(element).parent().parent().prev('table').addClass('closed');
}


// Forms

function formBirthDate(date) {
    if (date.day.length == 1) date.day = `0${date.day}`;
    if (date.month.length == 1) date.month = `0${date.month}`;

    const newDate = `${date.day}/${date.month}/${date.year}`;

    const fieldDiv = jQuery('.field.birth-date');

    fieldDiv[0].dataset.customFieldValue = newDate;

    fieldDiv.find('input')[0].value = newDate;
}

function formCustomSelectToggle(element) {
    const currentElement = jQuery(element);
    currentElement.closest('.field').toggleClass('open');
}

function formCustomSelectOption(element) {
    const currentElement = jQuery(element);
    if (currentElement.hasClass('current')) return;

    const fieldDiv = currentElement.closest('.field');
    fieldDiv[0].dataset.customFieldValue = jQuery(element).find('.option')[0].dataset.value;

    fieldDiv.find('.current').removeClass('current');

    const selectedDiv = fieldDiv.find('.selected');
    selectedDiv.find('.option').remove();

    selectedDiv.find('.option-wrapper').append(jQuery(element).find('.option').clone());

    currentElement.addClass('current');

    currentElement.closest('.field').toggleClass('open');
}

function formCustomSelectTelOption(element, telInputId) {
    const currentElement = jQuery(element);
    if (currentElement.hasClass('current')) return;

    const fieldDiv = currentElement.closest('.field');
    fieldDiv[0].dataset.customFieldValue = jQuery(element).find('.option')[0].dataset.value;

    fieldDiv.parent().find(`#${telInputId}`)[0].dataset.countryCode = jQuery(element).find('.option')[0].dataset.value;

    fieldDiv.find('.current').removeClass('current');

    const selectedDiv = fieldDiv.find('.selected');
    selectedDiv.find('.option').remove();

    selectedDiv.find('.option-wrapper').append(jQuery(element).find('.option').clone());

    currentElement.addClass('current');

    currentElement.closest('.field').toggleClass('open');
}

function formCustomMultiSelectOption(event) {
    const currentElement = jQuery(event.currentTarget);
    currentElement.toggleClass('current')

    if (!event.shiftKey) currentElement.closest('.options').find('.current').each((index, el) => el == event.currentTarget ? '' : jQuery(el).removeClass('current'));

    const fieldDiv = currentElement.closest('.field');

    let values = '';
    fieldDiv.find('.current').each((index, el) => values += index == 0 ? jQuery(el).find('.option')[0].dataset.value : (`,${jQuery(el).find('.option')[0].dataset.value}`));

    fieldDiv[0].dataset.customFieldValues = values;
}

function formClean(formDiv) {
    const errorFields = formDiv.find('.error');
    errorFields.each((index, field) => {
        const fieldErrors = jQuery(field).children();

        if (fieldErrors.length > 0) fieldErrors.each((index, error) => jQuery(error).remove());
    })

    const errorInput = formDiv.find('input.error');
    errorInput.each((index, field) => {
        jQuery(field).toggleClass('error');
    })

    const successDiv = formDiv.find('.success');
    if (successDiv.length > 0) {
        const successMessage = successDiv.children(':first');

        if (successMessage.length > 0) successMessage.remove();
    }
}

function formGetData(formFields, formIdentifier, formTypePostId) {
    const formData = new FormData();

    formData.append('wp_site_id', wp_site_id);
    formData.append('wp_post_id', wp_post_id);
    formData.append('form_identifier', formIdentifier);
    formData.append('form_type_post_id', formTypePostId);

    const fieldsData = {};

    formFields.each((index, field) => {
        const currentFieldDiv = jQuery(field);

        if (field.dataset.customFieldType == undefined) {
            const inputs = currentFieldDiv.find('textarea, input:not([type="checkbox"]), select'); // Checkbox has to be custom field
            if (inputs[0].name == 'password' || inputs[0].name == 'confirm-password' || inputs[0].name == 'current-password') inputs[0].type = 'password'; // Making sure that password and confirm password fields types are password and not text because of show/hide password

            fieldsData[inputs[0].name] = {
                name: inputs[0].name,
                type: inputs[0].type,
                full_validate: inputs[0].dataset.fullvalidate == 0 ? 0 : 1 // always 1 unless specified to be 0 
            }

            if (inputs[0].type == 'radio') {
                inputs.each((index, el) => {
                    if (el.checked) fieldsData[el.name].value = el.value;
                    else if (fieldsData[el.name].value == undefined) fieldsData[el.name].value = '';

                    if (el.required) fieldsData[el.name].required = el.required;
                    else if (fieldsData[el.name].required == undefined) fieldsData[el.name].required = false;
                })
            }
            else if (inputs[0].type == 'file') {
                formData.append(`attachment_${inputs[0].name}`, inputs[0].files[0]);

                fieldsData[inputs[0].name].value = inputs[0].files.length > 0 ? `attachment_${inputs[0].name}` : '';
                fieldsData[inputs[0].name].required = inputs[0].required;
                fieldsData[inputs[0].name].maximum_size = inputs[0].dataset.maximumSize ? Number(inputs[0].dataset.maximumSize) : '';
            }
            else if (inputs[0].type == 'select-multiple') {
                fieldsData[inputs[0].name].values = jQuery(inputs[0]).val();
                fieldsData[inputs[0].name].required = inputs[0].required;
            }
            else if (inputs[0].type == 'tel') {
                fieldsData[inputs[0].name].country_code = inputs[0].dataset.countryCode;
                fieldsData[inputs[0].name].value = inputs[0].value;
                fieldsData[inputs[0].name].required = inputs[0].required;
            }
            else {
                fieldsData[inputs[0].name].value = inputs[0].value;
                fieldsData[inputs[0].name].required = inputs[0].required;
            }
        }
        else {
            fieldsData[field.dataset.customFieldName] = {
                name: field.dataset.customFieldName,
                type: field.dataset.customFieldType,
                required: field.dataset.customFieldRequired == 1 ? true : false
            }

            if (field.dataset.customFieldType == 'checkbox') {
                fieldsData[field.dataset.customFieldName].values = [];

                jQuery(field).find(':checked').each((index, el) => fieldsData[field.dataset.customFieldName].values.push(el.value));
            }
            else if (field.dataset.customFieldType == 'select-one' || field.dataset.customFieldType == 'date') fieldsData[field.dataset.customFieldName].value = field.dataset.customFieldValue;
            else if (field.dataset.customFieldType == 'select-multiple') fieldsData[field.dataset.customFieldName].values = field.dataset.customFieldValues ? field.dataset.customFieldValues.split(',') : [];
        }
    })

    formData.append('fields', JSON.stringify(fieldsData));

    return formData;
}

function formErrors(errors, formFields) {
    for (const [key, values] of Object.entries(errors)) {
        formFields.each((index, field) => {
            if ((field.dataset.customFieldType == undefined && jQuery(field).find('textarea, input:not([type="checkbox"]), select')[0].name == key) || field.dataset.customFieldName == key) {
                const errorDiv = jQuery(field).find('.error:not(input)');
                values.forEach(message => layoutHeading('span', message, null, errorDiv[0]));

                jQuery(field).find('input').addClass('error');
            }
        })
    }
}

function formSuccess(formDiv, success) {

    if (success.action == 'redirect') location.replace(success.value);
    else if (success.action == 'success_message') formSuccessMessage(formDiv, success.value);
    else if (success.action == 'success_div') formSuccessDiv(formDiv, success.value);
    else if (success.action == 'none') return;
    //else location.reload();
    //formSuccessMessage(formDiv, success.value);
    $('#form-contact').addClass('sucess');
    $('.success-message').removeClass('hidden');

}

function formSuccessMessage(formDiv, successMessage) {
    const successDiv = formDiv.find('.success');
    if (successDiv.length > 0) layoutHeading('span', successMessage, null, successDiv[0]);
}

function formSuccessDiv(formDiv, successValue) {
    jQuery('.' + successValue.show).toggleClass('hide');
    jQuery('.' + successValue.hide).remove();
}

function formSubmit(formIdentifier, formTypePostId, element = null) {
    const formDiv = element ? jQuery(element).closest(`#form-${formIdentifier}`) : jQuery(`#form-${formIdentifier}`);

    const formFields = formDiv.find('.field:not(:has(input[type="button"]))');

    formClean(formDiv);

    const formData = formGetData(formFields, formIdentifier, formTypePostId);

    const url = document.location.origin + '/pt-br/apostas/wp-content/themes/os-betting-child/ajax/forms.php';

    jQuery.ajax({
        url: url,
        method: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function (data) {
            if (data.success) {
                formFields.find('input').val('');
                formSuccess(formDiv, data.success);

                if (formIdentifier == 'crmpopup') {
                    //handleCRMPopUpSubscribed(formDiv);
                }
            }
            else {
                formErrors(data.errors, formFields);
            }
        },
        dataType: 'json'
    });
}

// Copy Link Popup
function copyToClipboardAndPopup(element, copyURL) {
    const currentElement = jQuery(element);
    currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });

    if (!copyURL) navigator.clipboard.writeText(window.location.href);
    else {
        navigator.clipboard.writeText(copyURL);

        setTimeout(() => {
            currentElement.parent().children().each(function () { jQuery(this).toggleClass('active'); });
        }, 2 * 1000);
    }

    // $('.social-sharing').removeClass('hidden');
    $('.snackbar').removeClass('closed');
    $('.snackbar .closeButton').on('click', function () {
        $('.snackbar').addClass('closed');
    });

    // $('.social-sharing').on('click',function(){
    //     $('.social-sharing').addClass('hidden');
    // });

    setTimeout(() => {
        $('.snackbar').addClass('closed');
        //$('.social-sharing').addClass('hidden');
    }, 2 * 2000);

}

// Pop Ups
// function closePopUp() {
//     // Pop Ups need to have an unique id and a class with the same name as the id
//     const bodyDiv = jQuery(document.body);

//     const popUpDiv = bodyDiv.find('.pop-up');
//     if (!popUpDiv.length) return;

//     const popUpId = popUpDiv[0].id;

//     popUpDiv.remove();

//     bodyDiv.removeClass(`pop-up ${popUpId}`);
// }

// function notRecommendedPopUpEscape() {
//     jQuery(document).click(event => {
//         const divToEscape = jQuery('.pop-up.not-recommended > .container');

//         const divToIgnoreIfClicked = jQuery('header');

//         if (divToEscape.length > 0) {
//             if ((!divToEscape.is(event.target) && divToEscape.has(event.target).length == 0) && (!divToIgnoreIfClicked.is(event.target) && divToIgnoreIfClicked.has(event.target).length == 0)) {
//                 divToEscape.parent().remove();

//                 jQuery(document.body).removeClass('pop-up');
//             }
//         }
//     })
// }
// Comparison Filters
function handleComparisonOrder(element) {
    if (jQuery(element).hasClass('active')) return;

    jQuery(element).parent().children().each(function () {
        jQuery(this).removeClass('active');
        jQuery(this).find('input[type="radio"]').prop('checked', false);
    });

    const order = jQuery(element).attr('class').replace('filter ', '');

    comparison_current_filter['order'] = order;

    jQuery(element).addClass('active');
    jQuery(element).find('input[type="radio"]').prop('checked', true);

    jQuery(element).closest('.order.responsiveness').toggleClass('opened');

    requestComparisonEntries();
}

function handleComparisonSearch(element) {
    const search_value = jQuery(element).val();

    if (search_value.length > 0 && search_value.length < 3) return;

    if (search_value.length == 0) comparison_current_filter['filter']['search'] = null;
    else comparison_current_filter['filter']['search'] = search_value;

    requestComparisonEntries();
}

function toggleAdvancedFilters(element) {
    jQuery(element).closest('.advanced-filters').toggleClass('opened');

    if (jQuery(element).closest('.advanced-filters').hasClass('opened')) escapeFilters(element);
}

function applyAdvancedFilters(element) {
    const toolbar = jQuery(element).closest('.toolbar');

    const toolbarFilters = toolbar.find('.middle').eq(0).children();

    let filter_counter = 0;

    toolbarFilters.each(function () {
        const filter = jQuery(this).attr('class').replace(' opened', '').replace('-', '_');

        let has_filtering = false;
        let values = [];

        const checkboxes = jQuery(this).find('input[type="checkbox"]');
        checkboxes.each(function () {
            if (jQuery(this).is(":checked")) {
                if (filter == 'apps') values.push(jQuery(this).val());
                else values.push(parseInt(jQuery(this).val()));
                has_filtering = true;
            }
        });

        const ranges = jQuery(this).find('input[type="range"]');
        ranges.each(function () {
            values.push(jQuery(this).val());
            has_filtering = true;
        });

        if (has_filtering) {
            comparison_current_filter['filter'][filter] = values;
            filter_counter++;
        }
        else comparison_current_filter['filter'][filter] = false;
    });

    requestComparisonEntries();

    jQuery(element).closest('.advanced-filters').toggleClass('opened');

    const toggle = jQuery(element).closest('.advanced-filters').find('.toggle').eq(0);

    const activeTitle = toggle.find('.active .title span');
    let base_title = activeTitle.html().split(' (')[0];
    activeTitle.html(base_title + ' (' + filter_counter + ')');

    const activeTitleMobile = toggle.find('.active .number span');
    activeTitleMobile.html(filter_counter);

    if (!(toggle.hasClass('active'))) toggle.addClass('active');
}

function clearAdvancedFilters(element, event) {
    event.stopPropagation();

    const toolbar = jQuery(element).closest('.advanced-filters').find('.toolbar').eq(0);

    const toolbarFilters = toolbar.find('.middle').eq(0).children();

    comparison_current_filter['filter'] = { ...comparison_default_filter['filter'] };

    toolbarFilters.each(function () {
        const filter = jQuery(this).attr('class').replace(' opened', '').replace('-', '_');

        const checkboxes = jQuery(this).find('input[type="checkbox"]');
        checkboxes.each(function () {
            if (jQuery(this).is(":checked")) jQuery(this).prop('checked', false)
        });

        const ranges = jQuery(this).find('input[type="range"]');
        ranges.each(function () {
            if (jQuery(this).hasClass('min')) jQuery(this).val(0);
            else jQuery(this).val(100);

            jQuery(this).parent().parent().find('.value').html('R$ 0 - R$ 100');

            jQuery(this).parent().find('.overlay').css('left', '7px');
            jQuery(this).parent().find('.overlay').css('width', 'calc(100% - 14px)');
        });
    });

    requestComparisonEntries();

    if (jQuery(element).closest('.advanced-filters').hasClass('opened')) jQuery(element).closest('.advanced-filters').removeClass('opened');

    const toggle = jQuery(element).closest('.advanced-filters').find('.toggle').eq(0);

    const activeTitle = toggle.find('.active .title span');
    let base_title = activeTitle.html().split(' (')[0];
    activeTitle.html(base_title + ' (0)');

    const activeTitleMobile = toggle.find('.active .number span');
    activeTitleMobile.html('0');

    if (toggle.hasClass('active')) toggle.removeClass('active');
}

function toggleOrderFilters(element) {
    jQuery(element).closest('.order').toggleClass('opened');

    escapeFilters(element);
}

function escapeFilters(element) {
    jQuery(document).click(event => {
        const divToEscape = jQuery(element).parent().find('.toolbar');

        const divToIgnoreIfClicked = jQuery(element);

        if (divToEscape.length > 0) {
            if ((!divToEscape.is(event.target) && divToEscape.has(event.target).length == 0) && !divToIgnoreIfClicked.is(event.target) && divToIgnoreIfClicked.has(event.target).length == 0) {
                jQuery(element).closest('.advanced-filters').removeClass('opened');
                jQuery(element).closest('.order').removeClass('opened');
            }
        }
    })
}

function toggleAdvancedFilter(element) {
    jQuery(element).parent().toggleClass('opened');
}

function rangeInputChangeEventHandler(e) {
    const minBtn = jQuery(this).parent().children('.min');
    const maxBtn = jQuery(this).parent().children('.max');
    var minVal = parseInt(jQuery(minBtn).val());
    var maxVal = parseInt(jQuery(maxBtn).val());
    const origin = jQuery(e.target).attr('class');

    if (origin === 'min' && minVal > maxVal - 5) {
        jQuery(minBtn).val(maxVal - 5);
    }
    minVal = parseInt(jQuery(minBtn).val());

    if (origin === 'max' && maxVal - 5 < minVal) {
        jQuery(maxBtn).val(5 + minVal);
    }
    maxVal = parseInt(jQuery(maxBtn).val());

    const baseWidth = jQuery(minBtn).width();
    const stepWidth = baseWidth / 100;

    const overlay = jQuery(this).parent().children('.overlay');
    jQuery(overlay).css('left', ((minVal * stepWidth)) + 'px');
    jQuery(overlay).css('width', ((baseWidth - (minVal * stepWidth) - (baseWidth - (maxVal * stepWidth)))) + 'px');

    jQuery(this).parent().parent().find('.value').html('R$ ' + minVal + ' - ' + 'R$ ' + maxVal);
}

function requestComparisonEntries() {
    const cardsDiv = jQuery('.sportsbooks .cards').eq(0);

    if (!comparison.data) {
        comparison.fetchingData = true;

        const url = `${ajaxChildThemeUrlPrefix}comparison-cards.php`;

        jQuery.ajax({
            url: url,
            data: {
                wp_site_id: wp_site_id,
                wp_post_id: wp_post_id
            },
            success: function (data) {
                if (!data.entries) return;

                comparison.data = {};

                comparison.data.style = data.style;

                comparison.data.entries = data.entries.sort(function (a, b) {
                    if (comparison_current_filter['order'] == 'relevance') {
                        return parseInt(b.setup.priority) - parseInt(a.setup.priority);
                    }
                    else if (comparison_current_filter['order'] == 'ranking') {
                        return parseFloat(b.rating) - parseFloat(a.rating);

                    }
                    else if (comparison_current_filter['order'] == 'new') {
                        var aDate = new Date(a.license.approval_date);
                        var bDate = new Date(b.license.approval_date);

                        return bDate.getTime() - aDate.getTime();
                    }
                });

                let filtered_entries = comparison.data.entries.filter(advRow =>
                    (comparison_current_filter.filter.search ? advRow.advertiser.name.toLowerCase().includes(comparison_current_filter.filter.search.toLowerCase()) : true) &&
                    (comparison_current_filter.filter.apps ? advRow.apps.find(app => comparison_current_filter.filter.apps.includes(app.app_support.toLowerCase())) : true) &&
                    (comparison_current_filter.filter.minimum_deposit ? (parseInt(advRow.minimum_deposit.replace(/\D/g, "")) >= comparison_current_filter.filter.minimum_deposit[0] && parseInt(advRow.minimum_deposit.replace(/\D/g, "")) <= comparison_current_filter.filter.minimum_deposit[1]) : true) &&
                    (comparison_current_filter.filter.minimum_withdrawal ? (parseInt(advRow.minimum_withdrawal.replace(/\D/g, "")) >= comparison_current_filter.filter.minimum_withdrawal[0] && parseInt(advRow.minimum_withdrawal.replace(/\D/g, "")) <= comparison_current_filter.filter.minimum_withdrawal[1]) : true) &&
                    (comparison_current_filter.filter.payment_methods ? advRow.payment_methods.find(payment => comparison_current_filter.filter.payment_methods.includes(payment.id)) : true) &&
                    (comparison_current_filter.filter.offers ? advRow.offers.find(offer => comparison_current_filter.filter.offers.includes(offer.id)) : true) &&
                    (comparison_current_filter.filter.functionalities ? advRow.functionalities.find(functionality => comparison_current_filter.filter.functionalities.includes(functionality.id)) : true)
                );

                handleComparisonEntries(cardsDiv, filtered_entries, comparison.data.style);

                comparison.fetchingData = false;
            },
            dataType: 'json'
        });
    }
    else {
        comparison.data.entries = comparison.data.entries.sort(function (a, b) {
            if (comparison_current_filter['order'] == 'relevance') {
                return parseInt(b.setup.priority) - parseInt(a.setup.priority);
            }
            else if (comparison_current_filter['order'] == 'ranking') {
                return parseFloat(b.rating) - parseFloat(a.rating);

            }
            else if (comparison_current_filter['order'] == 'new') {
                var aDate = new Date(a.license.approval_date);
                var bDate = new Date(b.license.approval_date);

                return bDate.getTime() - aDate.getTime();
            }
        });

        let filtered_entries = comparison.data.entries.filter(advRow =>
            (comparison_current_filter.filter.search ? advRow.advertiser.name.toLowerCase().includes(comparison_current_filter.filter.search.toLowerCase()) : true) &&
            (comparison_current_filter.filter.apps ? advRow.apps.find(app => comparison_current_filter.filter.apps.includes(app.app_support.toLowerCase())) : true) &&
            (comparison_current_filter.filter.minimum_deposit ? (parseInt(advRow.minimum_deposit.replace(/\D/g, "")) >= comparison_current_filter.filter.minimum_deposit[0] && parseInt(advRow.minimum_deposit.replace(/\D/g, "")) <= comparison_current_filter.filter.minimum_deposit[1]) : true) &&
            (comparison_current_filter.filter.minimum_withdrawal ? (parseInt(advRow.minimum_withdrawal.replace(/\D/g, "")) >= comparison_current_filter.filter.minimum_withdrawal[0] && parseInt(advRow.minimum_withdrawal.replace(/\D/g, "")) <= comparison_current_filter.filter.minimum_withdrawal[1]) : true) &&
            (comparison_current_filter.filter.payment_methods ? advRow.payment_methods.find(payment => comparison_current_filter.filter.payment_methods.includes(payment.id)) : true) &&
            (comparison_current_filter.filter.offers ? advRow.offers.find(offer => comparison_current_filter.filter.offers.includes(offer.id)) : true) &&
            (comparison_current_filter.filter.functionalities ? advRow.functionalities.find(functionality => comparison_current_filter.filter.functionalities.includes(functionality.id)) : true)
        );

        handleComparisonEntries(cardsDiv, filtered_entries, comparison.data.style);
    }
}

function handleComparisonEntries(cardsDiv, data, style) {
    cardsDiv.children().each((index, el) => jQuery(el).remove());

    const showMoreDiv = jQuery('.sportsbooks .show-more').eq(0);

    const noResultsDiv = jQuery('.sportsbooks .no-results').eq(0);

    if (data.length > 10) {
        if (showMoreDiv.hasClass('hide')) showMoreDiv.removeClass('hide');
    }
    else if (!(showMoreDiv.hasClass('hide'))) showMoreDiv.addClass('hide');

    if (data.length == 0) {
        if (noResultsDiv.hasClass('hide')) noResultsDiv.removeClass('hide');
    }
    else if (!(noResultsDiv.hasClass('hide'))) noResultsDiv.addClass('hide');

    if (data) {
        for (i = 0; i < data.length; i++) {
            createAdvertiserGeographicalAreaHorizontalLongComparisonCard(data[i], cardsDiv[0], style, (!(showMoreDiv.hasClass('hide')) && i > 9) ? ' hide' : '', i + 1);
        }
    }
}

// Layout Comparison
function createAdvertiserGeographicalAreaHorizontalLongComparisonCard(advertiser_geographical_area, parent, style, css_class = null, rank = null) {
    const cardDiv = layoutElement('div', 'advertiser-geographical-area horizontal large card comparison' + css_class + ' ' + (advertiser_geographical_area.status.toLowerCase().replace(' ', '-')), parent);

    if (advertiser_geographical_area.identifier) jQuery(cardDiv).attr('data-os_adv_id', advertiser_geographical_area.identifier);
    if (advertiser_geographical_area.marketing_source_identifier) jQuery(cardDiv).attr('data-os_ms', advertiser_geographical_area.marketing_source_identifier);
    if (rank) jQuery(cardDiv).attr('data-os_r', rank);
    jQuery(cardDiv).attr('data-os_element', 'Comparison');

    layoutAdvertiserGeographicalAreaButton(advertiser_geographical_area.donation_links.comparison, null, null, null, 'area-link', cardDiv, '_blank', 'nofollow', 'Comparison', null, 'Comparison', null, null, null);

    const wrapperDiv = layoutElement('div', 'wrapper', cardDiv);

    const topDiv = layoutElement('div', 'top', wrapperDiv);

    const topLeftDiv = layoutElement('div', 'left', topDiv);

    const topLeftTopDiv = layoutElement('div', 'top', topLeftDiv);

    const topLeftTopRankDiv = layoutElement('div', 'rank', topLeftTopDiv);
    layoutHeading('span', (rank < 10 ? '0' : '') + rank, null, topLeftTopRankDiv);

    const topLeftTopLogoDiv = layoutElement('div', 'logo', topLeftTopDiv);
    layoutImage(advertiser_geographical_area.assets.favicon, null, topLeftTopLogoDiv);
    jQuery(topLeftTopLogoDiv).css('background-color', advertiser_geographical_area.assets.primary_color);

    const topLeftTopColumnDiv = layoutElement('div', 'column', topLeftTopDiv);

    const topLeftTopColumnNameDiv = layoutElement('div', 'sportsbook-name', topLeftTopColumnDiv);
    layoutHeading('span', advertiser_geographical_area.advertiser.name, null, topLeftTopColumnNameDiv);

    // if(advertiser_geographical_area.brain_library.wp_fields.overview.settings_tag.title) {
    //     const topLeftTopColumnTagDiv = layoutElement('div', 'tag', topLeftTopColumnDiv);
    //     layoutHeading('span', advertiser_geographical_area.brain_library.wp_fields.overview.settings_tag.title, null, topLeftTopColumnTagDiv);
    // }

    const topLeftTopRatingDiv = layoutElement('div', 'rating', topLeftTopDiv);

    const topLeftTopRatingStarsDiv = layoutElement('div', 'stars', topLeftTopRatingDiv);
    layoutImage(style.star_icon, null, topLeftTopRatingStarsDiv);

    const topLeftTopRatingComposedDiv = layoutElement('div', 'composed', topLeftTopRatingDiv);
    layoutHeading('span', (advertiser_geographical_area.rating / 20).toFixed(1).replace('.', '.'), 'bold', topLeftTopRatingComposedDiv);

    const topLeftBottomDiv = layoutElement('div', 'bottom', topLeftDiv);

    const topLeftBottomFeaturesDiv = layoutElement('div', 'features', topLeftBottomDiv);

    if (advertiser_geographical_area.minimum_deposit) {
        const topLeftBottomFeaturesMinimumDepositDiv = layoutElement('div', 'minimum-deposit', topLeftBottomFeaturesDiv);

        const topLeftBottomFeaturesMinimumDepositLabelDiv = layoutElement('div', 'label', topLeftBottomFeaturesMinimumDepositDiv);
        layoutHeading('span', style.labels_information.minimum_deposit, null, topLeftBottomFeaturesMinimumDepositLabelDiv);

        const topLeftBottomFeaturesMinimumDepositContentDiv = layoutElement('div', 'content', topLeftBottomFeaturesMinimumDepositDiv);
        layoutHeading('span', advertiser_geographical_area.minimum_deposit + ',00', null, topLeftBottomFeaturesMinimumDepositContentDiv);
    }

    if (advertiser_geographical_area.payment_methods.length != 0) {
        const topLeftBottomFeaturesPaymentMethodsDiv = layoutElement('div', 'payment-methods', topLeftBottomFeaturesDiv);

        const topLeftBottomFeaturesPaymentMethodsLabelDiv = layoutElement('div', 'label', topLeftBottomFeaturesPaymentMethodsDiv);
        layoutHeading('span', style.labels_information.payment_methods, null, topLeftBottomFeaturesPaymentMethodsLabelDiv);

        const topLeftBottomFeaturesPaymentMethodsContentDiv = layoutElement('div', 'content', topLeftBottomFeaturesPaymentMethodsDiv);

        advertiser_geographical_area.payment_methods.forEach(payment_method => {
            let paymentMethodIcon = layoutElement('div', 'icon', topLeftBottomFeaturesPaymentMethodsContentDiv);
            layoutTitle('span', payment_method.name, payment_method.asset, null, paymentMethodIcon);
            jQuery(paymentMethodIcon).css('background-color', payment_method.primary_color)
        });
    }

    if (advertiser_geographical_area.apps.length != 0) {
        const topLeftBottomFeaturesAppsDiv = layoutElement('div', 'apps', topLeftBottomFeaturesDiv);

        const topLeftBottomFeaturesAppsLabelDiv = layoutElement('div', 'label', topLeftBottomFeaturesAppsDiv);
        layoutHeading('span', style.labels_information.apps, null, topLeftBottomFeaturesAppsLabelDiv);

        const topLeftBottomFeaturesAppsContentDiv = layoutElement('div', 'content', topLeftBottomFeaturesAppsDiv);

        advertiser_geographical_area.apps.forEach(app => {
            let appIcon = layoutElement('div', 'icon', topLeftBottomFeaturesAppsContentDiv);
            layoutImage(app.icon, null, appIcon);
        });
    }

    const topMiddleDiv = layoutElement('div', 'middle', topDiv);

    const topMiddleTopDiv = layoutElement('div', 'top', topMiddleDiv);

    const topMiddleTopTitleDiv = layoutElement('div', 'title', topMiddleTopDiv);
    layoutHeading('span', style.labels_bonus.title, null, topMiddleTopTitleDiv);

    const topMiddleBottomDiv = layoutElement('div', 'bottom', topMiddleDiv);

    const topMiddleBottomBonusDiv = layoutElement('div', 'bonus', topMiddleBottomDiv);

    const topMiddleBottomBonusOfferDiv = layoutElement('div', 'offer', topMiddleBottomBonusDiv);
    layoutAdvertiserGeographicalAreaButton(advertiser_geographical_area.donation_links.comparison, 'span', advertiser_geographical_area.bonus_string, null, null, topMiddleBottomBonusOfferDiv, '_blank', 'nofollow', 'Comparison', null, 'Card', null, null, null);

    // if(advertiser_geographical_area.bonus_code) {
    //     const topMiddleBottomCopyDiv = layoutElement('div', 'copy', topMiddleBottomDiv);

    //     const topMiddleBottomCopyTitleDiv = layoutElement('div', 'title active', topMiddleBottomCopyDiv);
    //     layoutTitle('span', advertiser_geographical_area.bonus_code, style.buttons_copy.title.icon, null, topMiddleBottomCopyTitleDiv);
    //     jQuery(topMiddleBottomCopyTitleDiv).click(function() { copyToClipboard(this, advertiser_geographical_area.bonus_code); })

    //     const topMiddleBottomCopySuccessDiv = layoutElement('div', 'success', topMiddleBottomCopyDiv);
    //     layoutTitle('span', style.buttons_copy.success.title, style.buttons_copy.success.icon, null, topMiddleBottomCopySuccessDiv);
    // }

    const topRightDiv = layoutElement('div', 'right', topDiv);

    const topRightButtonsDiv = layoutElement('div', 'buttons', topRightDiv);

    const topRightButtonsDonationLinkDiv = layoutElement('div', 'donation-link', topRightButtonsDiv);
    layoutAdvertiserGeographicalAreaButton(advertiser_geographical_area.donation_links.comparison, 'span', style.buttons_long_donation.title, null, null, topRightButtonsDonationLinkDiv, '_blank', 'nofollow', 'Comparison', null, 'Card', null, null, null);

    if (advertiser_geographical_area.review) {
        const topRightButtonsReviewDiv = layoutElement('div', 'review', topRightButtonsDiv);
        //layoutButton(advertiser_geographical_area.review, 'span', style.buttons_long_review.title, style.buttons_long_review.icon, null, topRightButtonsReviewDiv);
    }

    const topRightFeaturesDiv = layoutElement('div', 'features responsiveness', topRightDiv);

    if (advertiser_geographical_area.minimum_deposit) {
        const topLeftBottomFeaturesMinimumDepositDiv = layoutElement('div', 'minimum-deposit', topRightFeaturesDiv);

        const topLeftBottomFeaturesMinimumDepositLabelDiv = layoutElement('div', 'label', topLeftBottomFeaturesMinimumDepositDiv);
        layoutHeading('span', style.labels_information.minimum_deposit, null, topLeftBottomFeaturesMinimumDepositLabelDiv);

        const topLeftBottomFeaturesMinimumDepositContentDiv = layoutElement('div', 'content', topLeftBottomFeaturesMinimumDepositDiv);
        layoutHeading('span', advertiser_geographical_area.minimum_deposit + ',00', null, topLeftBottomFeaturesMinimumDepositContentDiv);
    }

    if (advertiser_geographical_area.payment_methods.length != 0) {
        const topLeftBottomFeaturesPaymentMethodsDiv = layoutElement('div', 'payment-methods', topRightFeaturesDiv);

        const topLeftBottomFeaturesPaymentMethodsLabelDiv = layoutElement('div', 'label', topLeftBottomFeaturesPaymentMethodsDiv);
        layoutHeading('span', style.labels_information.payment_methods, null, topLeftBottomFeaturesPaymentMethodsLabelDiv);

        const topLeftBottomFeaturesPaymentMethodsContentDiv = layoutElement('div', 'content', topLeftBottomFeaturesPaymentMethodsDiv);

        advertiser_geographical_area.payment_methods.forEach(payment_method => {
            let paymentMethodIcon = layoutElement('div', 'icon', topLeftBottomFeaturesPaymentMethodsContentDiv);
            layoutTitle('span', payment_method.name, payment_method.asset, null, paymentMethodIcon);
            jQuery(paymentMethodIcon).css('background-color', payment_method.primary_color)
        });
    }

    if (advertiser_geographical_area.apps.length != 0) {
        const topLeftBottomFeaturesAppsDiv = layoutElement('div', 'apps', topRightFeaturesDiv);

        const topLeftBottomFeaturesAppsLabelDiv = layoutElement('div', 'label', topLeftBottomFeaturesAppsDiv);
        layoutHeading('span', style.labels_information.apps, null, topLeftBottomFeaturesAppsLabelDiv);

        const topLeftBottomFeaturesAppsContentDiv = layoutElement('div', 'content', topLeftBottomFeaturesAppsDiv);

        advertiser_geographical_area.apps.forEach(app => {
            let appIcon = layoutElement('div', 'icon', topLeftBottomFeaturesAppsContentDiv);
            layoutImage(app.icon, null, appIcon);
        });
    }

    if (advertiser_geographical_area.tc_excerpt) {
        const bottomDiv = layoutElement('div', 'bottom', wrapperDiv);

        const bottomLeftDiv = layoutElement('div', 'left', bottomDiv);

        const bottomLeftLicenseDiv = layoutElement('div', 'license', bottomLeftDiv);
        layoutHeading('span', advertiser_geographical_area.license.identifier, null, bottomLeftLicenseDiv);

        const bottomLeftExcerptDiv = layoutElement('div', 'tc-excerpt', bottomLeftDiv);
        layoutHeading('span', advertiser_geographical_area.tc_excerpt, null, bottomLeftExcerptDiv);

        const bottomRightDiv = layoutElement('div', 'right', bottomDiv);

        const bottomRightIconDiv = layoutElement('div', 'icon', bottomRightDiv);
        layoutImage(style.legal_icon, null, bottomRightIconDiv);
    }
}

function layoutAdvertiserGeographicalAreaButton(link, heading, title, icon, css_class, parent, target = null, rel = null, placement = null, link_type = null, section = null, rank = null, advertiser_geographical_area_identifier = null, marketing_source_identifier = null) {
    if (link === null) return layoutTitle(heading, title, icon, css_class, parent);

    var a = document.createElement('a');
    a.className = 'os-ms';

    if (css_class !== null) jQuery(a).addClass(css_class);
    a.href = link['url'];
    a.title = link['title'];
    if (target !== null) a.target = target;
    if (rel !== null) a.rel = rel;
    a.setAttribute("data-os_aga", link['title']);
    if (placement !== null) a.setAttribute("data-os_dlp", placement);
    if (link_type !== null) a.setAttribute("data-os_dlt", link_type);
    if (section !== null) a.setAttribute("data-os_element", section);
    if (advertiser_geographical_area_identifier !== null) a.setAttribute("data-os_adv_id", advertiser_geographical_area_identifier);
    if (rank !== null) a.setAttribute("data-os_r", rank);
    if (marketing_source_identifier !== null) a.setAttribute("data-os_ms", marketing_source_identifier);

    if (title !== null) layoutHeading(heading, title, '', a);

    if (icon !== null) layoutImage(icon, '', a);

    parent.appendChild(a);

    return a;
}

function handleHeroCardsNavigation(element, step) {
    const sportsgridElement = jQuery(element).parents().find('.sportsbooks-grid');

    if (sportsgridElement && sportsgridElement.length > 0) {
        const cards = sportsgridElement.find('.card');
        if (cards && cards.length > 0) {
            const card = jQuery(cards[0]);
            const width = card.outerWidth();

            if (step == 1) sportsgridElement.scrollLeft(sportsgridElement.scrollLeft() + width);
            if (step == -1) sportsgridElement.scrollLeft(sportsgridElement.scrollLeft - width);
        }
    }
}

function handleSearchCardsNavigation(element, step) {
    const sportsgridElement = jQuery(element).parent().parent().parent().find('.cards');

    if (sportsgridElement && sportsgridElement.length > 0) {
        const cards = sportsgridElement.find('.card');
        if (cards && cards.length > 0) {
            const card = jQuery(cards[0]);
            const width = card.outerWidth();

            if (step == 1) sportsgridElement.scrollLeft(sportsgridElement.scrollLeft() + width);
            if (step == -1) sportsgridElement.scrollLeft(sportsgridElement.scrollLeft - width);
        }
    }
}

function handleLatestNewsNavigation(element, step) {
    const gridElement = jQuery(element).parent().parent().parent().find('.cards-container');

    if (gridElement && gridElement.length > 0) {
        const cards = gridElement.find('.card');
        if (cards && cards.length > 0) {
            const card = jQuery(cards[0]);
            const width = card.outerWidth();

            if (step == 1) gridElement.scrollLeft(gridElement.scrollLeft() + width);
            if (step == -1) gridElement.scrollLeft(gridElement.scrollLeft - width);
        }
    }
}

function handleWhoWinsNavigation(element, step) {
    const gridElement = jQuery(element).parent().parent().parent().find('.cards');

    if (gridElement && gridElement.length > 0) {
        const cards = gridElement.find('.card');
        if (cards && cards.length > 0) {
            const card = jQuery(cards[0]);
            const width = card.outerWidth();

            if (step == 1) gridElement.scrollLeft(gridElement.scrollLeft() + width);
            if (step == -1) gridElement.scrollLeft(gridElement.scrollLeft - width);
        }
    }
}

function togglePopUpOnClickOutside(event, remove = false) {
    if (event.target && (event.target == event.currentTarget)) {
        if (remove) {
            const targetElement = $(event.target);
            targetElement.remove();
        }

        removeBodyPopUpClasses();
    }
}

function togglePopUp(popUpId) {
    if (jQuery(document.body).hasClass(`${popUpId}`)) {
        removeBodyPopUpClasses();
    }

    else {
        removeBodyPopUpClasses();
        jQuery(document.body).addClass(`${popUpId} pop-up`);
    }
}


function removeBodyPopUpClasses(canAccessPage = true) {
    if (canAccessPage) {
        const bodyEl = jQuery(document.body);

        const classes = bodyEl.attr('class').split(' ');
        classes.forEach(uniqueClass => {
            if (uniqueClass.includes('pop-up')) {
                bodyEl.removeClass(uniqueClass);
                bodyEl.removeClass('pop-up');
            }
        })
    }
}